import styles from "./styles.module.scss"
import React from "react"
import classNames from "classnames"

export const CruiseDetailsCard = ({
  title,
  subtitle = "",
  // testID,
  paddingEnabled = true,
  bottomPaddingEnabled = true,
  children,
}: {
  title: string
  subtitle?: string
  // testID?: string
  paddingEnabled?: boolean
  bottomPaddingEnabled?: boolean
  children: React.ReactNode
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.title}>{title}</p>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      <div
        className={classNames([
          paddingEnabled ? styles.paddingX : "",
          bottomPaddingEnabled ? styles.paddingBottom : "",
        ])}
      >
        {children}
      </div>
    </div>
  )
}
